<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},	
		methods: {
			abrirInputFile(data) {
				let inputFile = document.getElementById(`file-${data.id}`);
				if (inputFile) inputFile.click();
			},
			capturarAdjunto(event) {
				let file = event.target.files;
				let vm = this;
				try {
					var reader = new FileReader();
					reader.onload = function (event) {
						let fileContent = event.target.result;
						vm.data.value = fileContent;
					};
					reader.readAsDataURL(file[0]);
					vm.data.file_name = file[0].name;
				}
				catch(error) {
					console.log(error);
				}
			},
		},
		watch: {
			"data.value": {
				handler(value) {
					if(value) this.data.error = false;
					else this.data.error = true;
				},
				deep: true,
			}
		}
	}
</script>

<template>
	<div>
		<label class="form-label text-secondary">
			{{ data.label }}
		</label>
		<input 
			type="file"
			:id="`file-${data.id}`"
			class="d-none"
			@change="capturarAdjunto($event)"
			accept="image/*"
		>
		<a 
			href="javascript:"
			@click="abrirInputFile(data)"
			class="btn btn-custom-line btn-custom-line-gray w-100 text-start d-flex justify-content-between align-items-center"
			:class="{'border-danger': data.error && errorForm }"
		>
			<span>
				<font-awesome-icon icon="fa-solid fa-paperclip" class="me-2 color-main"></font-awesome-icon>
				<span v-if="!data.value">Adjuntar archivo</span>
				<span v-if="data.value"> {{ data.file_name }} </span>
			</span>
			<span v-if="data.value">
			<font-awesome-icon icon="fa-solid fa-check" class="color-green"></font-awesome-icon>
			</span>
		</a> 
		<div class="invalid-feedback">
			Debes adjuntar un documento
		</div>
	</div>
</template>